<ng-container *ngIf="expand">
    <div class="damage-claim-title" (click)="closeTitle.emit()">
        <div class="damage-claim-title__name">
            <svg class="svg-icon svg-icon--l"><use [attr.href]="'assets/icons-general.svg#' + icon"></use></svg>
            <h3>{{ title }}</h3>
        </div>
        <div class="damage-claim-title__icon">
            <svg class="svg-icon svg-icon--xs"><use href="assets/icons-ui.svg#pijl-up-bold"></use></svg>
        </div>
    </div>
</ng-container>

<ng-container *ngIf="!expand">
    <div class="damage-claim-title" (click)="openTitle.emit()">
        <div class="damage-claim-title__name">
            <svg class="svg-icon svg-icon--l"><use [attr.href]="'assets/icons-general.svg#' + icon"></use></svg>
            <h3>{{ title }}</h3>
        </div>
        <div class="damage-claim-title__icon">
            <svg class="svg-icon svg-icon--xs"><use href="assets/icons-ui.svg#pijl-down-bold"></use></svg>
        </div>
    </div>
</ng-container>
